// extracted by mini-css-extract-plugin
var _1 = "StepsHeaderStyle-module__step___Fqtkm";
var _2 = "StepsHeaderStyle-module__step-active___qyybD";
var _3 = "StepsHeaderStyle-module__step-inactive___uHdAb";
var _4 = "StepsHeaderStyle-module__step-active___qyybD";
var _5 = "StepsHeaderStyle-module__step-inactive___uHdAb";
var _6 = "StepsHeaderStyle-module__steps-header___P_MLM";
var _7 = "StepsHeaderStyle-module__steps-header___P_MLM";
export { _1 as "step", _2 as "step-active", _3 as "step-inactive", _4 as "stepActive", _5 as "stepInactive", _6 as "steps-header", _7 as "stepsHeader" }
